'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = order;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {};

function order() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'ORDER_USER_FETCH':
      return state;
    case 'ORDER_USER_FETCH_SUCCESS':
      return (0, _extends3.default)({}, state, action.result.order);
    case 'ORDER_USER_FETCH_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'ORDER_FETCH':
      return state;
    case 'ORDER_FETCH_SUCCESS':
      return (0, _extends3.default)({}, state, action.result.order);
    case 'ORDER_FETCH_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'ORDER_DELIVERY_ESTIMATE':
      return state;
    case 'ORDER_DELIVERY_ESTIMATE_SUCCESS':
      return (0, _extends3.default)({}, state, { shippingMethods: action.result.shippingMethods });
    case 'ORDER_DELIVERY_ESTIMATE_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'PAYMENT_METHODS_FETCH':
      return state;
    case 'PAYMENT_METHODS_FETCH_SUCCESS':
      return (0, _extends3.default)({}, state, { paymentMethodsResponse: action.result });
    case 'PAYMENT_METHODS_FETCH_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'ORDER_UPDATE':
      return state;
    case 'ORDER_UPDATE_SUCCESS':
      return (0, _extends3.default)({}, state, action.result.order);
    case 'ORDER_UPDATE_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'ORDER_NEXT':
      return state;
    case 'ORDER_NEXT_SUCCESS':
      return action.result.order;
    case 'ORDER_NEXT_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'ORDER_CLOSE':
      return {};
    case 'CHECKOUT_NEXT':
      return state;
    case 'CHECKOUT_NEXT_SUCCESS':
      return action.result.order;
    case 'CHECKOUT_NEXT_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'CHECKOUT_PAYMENT':
      return state;
    case 'CHECKOUT_PAYMENT_SUCCESS':
      return action.result.order;
    case 'CHECKOUT_PAYMENT_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'LINE_ITEM_REMOVE':
      return state;
    case 'LINE_ITEM_REMOVE_SUCCESS':
      return action.result.order;
    case 'LINE_ITEM_REMOVE_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'COUPON_REMOVE':
      return state;
    case 'COUPON_REMOVE_SUCCESS':
      return (0, _extends3.default)({}, state, action.result.order);
    case 'COUPON_REMOVE_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    case 'CHECKOUT_COUPON':
      return state;
    case 'CHECKOUT_COUPON_SUCCESS':
      return action.result.order;
    case 'CHECKOUT_COUPON_FAILURE':
      return (0, _extends3.default)({}, state, { error: action.error });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/order.js
// module id = 2352
// module chunks = 0